var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { useQueryClient, useMutation } from "@tanstack/react-query";
import { alternatePaymentMethodsCacheKey } from "../cacheKeys.js";
import deletionFnFactory from "./deletion.js";
function useAlternatePaymentMethodsDeletion({
  config,
  keyProps,
  mutationOptions = {}
}) {
  const queryClient = useQueryClient();
  return useMutation(__spreadValues({
    mutationKey: alternatePaymentMethodsCacheKey(keyProps),
    mutationFn: deletionFnFactory(config, keyProps),
    onSuccess: () => {
      return queryClient.invalidateQueries(
        alternatePaymentMethodsCacheKey(keyProps)
      );
    }
  }, mutationOptions));
}
export {
  useAlternatePaymentMethodsDeletion as default,
  useAlternatePaymentMethodsDeletion
};
//# sourceMappingURL=alternatePaymentMethodsDeletion.js.map
